<template>
  <div v-if="loaded"
       class="page-sms-verify"
  >
    <div class="page-sms-verify-title">输入验证码</div>
    <div class="page-sms-verify-content">
      <div class="page-sms-verify-content-left">已发送验证码至 <span>{{ mobile }}</span></div>
      <div class="page-sms-verify-content-right"
           :class="{ 'disable': smsCodeDisabled }"
           @click="handleSendSms"
      >
        {{ smsCodeText }}
      </div>
    </div>
    <verify-code-input :code.sync="smsCode" />
    <ym-button class="page-sms-verify-btn"
               type="primary"
               size="large"
               :disabled="smsCode.length !== 6"
               @click="handleConfirm"
    >
      确定
    </ym-button>
  </div>
</template>

<script>
  import { Button, Toast } from '@ymba/ym-ui';
  import { mapActions } from 'vuex';
  import VerifyCodeInput from '@/components/VerifyCodeInput';
  import { sendSmsCode, verifyMobile } from '@/services/user';
  import { SMS_CODE_DURATION } from '@/utils/constant';
  import { getStorageRedirect, locationPath, removeFromLocalStorage } from '@/utils';
  import geetestMixin from '@/mixins/geetest/geetest';

  export default {
    name: 'pageSmsVerify',
    mixins: [geetestMixin],
    metaInfo: {},
    components: {
      VerifyCodeInput,
      'ym-button': Button,
    },
    data() {
      return {
        loaded: false,
        mobile: '',
        type: '',
        smsCode: '',
        smsCodeText: '获取验证码',
        smsCodeDisabled: false,
      };
    },
    computed: {
      smsType() {
        switch (this.type) {
          case 'forgetPassword':
            return 'sms_forget_password';
          case 'login':
            return 'sms_login';
          case 'bindMobile':
            return 'sms_bind';
          default:
            return '';
        }
      },
    },
    watch: {
      smsCode(val) {
        if (val.length === 6) this.handleConfirm();
      },
    },
    methods: {
      ...mapActions([
        'Login',
        'BindMobile',
      ]),
      handleSendSms() {
        if (this.smsCodeDisabled) return;
        this.verifyGeetest();
      },
      async onGeetestSuccess(geetestData) {
        try {
          await sendSmsCode(this.mobile, this.smsType, geetestData);
          this.smsCodeDisabled = true;
          this.duration = SMS_CODE_DURATION;
          const t = setInterval(() => {
            if (this.duration <= 0) {
              this.smsCodeText = '重新获取';
              this.smsCodeDisabled = false;
              clearInterval(t);
              return;
            }
            this.smsCodeText = `重新获取（${this.duration}）`;
            this.duration -= 1;
          }, 1000);
          this.loaded = true;
        } catch (e) {
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        }
      },
      async handleConfirm() {
        // eslint-disable-next-line default-case
        switch (this.type) {
          case 'forgetPassword': {
            await verifyMobile(this.mobile, this.smsCode, this.smsType);
            this.$router.replace({
              name: 'PasswordReset',
              query: {
                mobile: this.mobile,
                smsCode: this.smsCode,
              },
            });
            break;
          }
          case 'login': {
            await this.Login({
              mobile: this.mobile,
              smsCode: this.smsCode,
              smsType: this.smsType,
            });
            const { redirectTo } = this.$route.query;
            const path = getStorageRedirect(redirectTo);
            locationPath(path, 1);
            removeFromLocalStorage('last-login-mobile');
            break;
          }
          case 'bindMobile': {
            const { mobile, smsCode } = this;
            await this.BindMobile({
              mobile,
              smsCode,
              wechat: '1',
            });
            const { redirectTo } = this.$route.query;
            const path = getStorageRedirect(redirectTo);
            locationPath(path, 1);
            removeFromLocalStorage('last-login-mobile');
          }
        }
      },
      onGeetestReady() {
        this.verifyGeetest();
      },
      onGeetestClose() {
        if (!this.loaded) this.$router.back();
      },
    },
    created() {
      if (this.$route.query.mobile && this.$route.query.type) {
        this.mobile = this.$route.query.mobile;
        this.type = this.$route.query.type;
        Toast.loading();
      }
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-sms-verify {
    min-height: 100%;
    background: @color-white;
    box-sizing: border-box;
    padding: 80px 50px;
    &-title {
      color: @color-black-dark;
      font-size: 56px;
      font-weight: @font-weight-bold;
    }
    &-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 30px 0 120px;
      &-left {
        color: @color-text-light;
        font-size: @font-size-base;
        font-weight: @font-weight-bold;
        span {
          color: @color-text-lighter;
        }
      }
      &-right {
        color: #13b9bf;
        font-size: @font-size-base;
        font-weight: @font-weight-bold;
        &.disable {
          color: @color-text-lighter;
        }
      }
    }
    &-btn {
      margin-top: 80px;
      margin-bottom: @size-extra-medium;
      border-radius: 25px;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      background-color: #02cccc;
      border: none;
      &.is-disabled {
        opacity: 1;
        background-color: @color-text-disabled;
      }
    }
  }
</style>
